import { getStateName } from 'lib/ssr-common'

export const getFragmentState = fragmentName => {
  return window[getStateName(fragmentName)]
}
